export default __webpack_public_path__ + "88dbc6b.png";